module.exports = __webpack_public_path__ + "static/media/intro21.bf9a3e71.png";